import { render, staticRenderFns } from "./availableProducts.vue?vue&type=template&id=10b06f39"
import script from "./availableProducts.vue?vue&type=script&lang=js"
export * from "./availableProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports